<div class="ss-page">
  <div class="ss-wrap">
    <a class="back" routerLink="/account/searches">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"></path></svg>
      Saved searches
    </a>

    <div class="skeleton" *ngIf="state === 'loading'" aria-label="Loading matches">
      <div class="sk-line"></div><div class="sk-line"></div><div class="sk-line short"></div>
    </div>

    <div class="loaderr" role="alert" *ngIf="state === 'error'">
      <p>We couldn't load this search's plates just now.</p>
      <button class="av2-btn av2-btn--ghost av2-btn--sm" (click)="load()">Try again</button>
    </div>

    <ng-container *ngIf="state === 'ready' && matches">
      <p class="eyebrow">Saved search</p>
      <div class="hd">
        <h1 class="stmt">{{ search?.plainSummary || matches.plainSummary }}</h1>
        <a class="av2-btn av2-btn--ghost av2-btn--sm" [routerLink]="['/account/searches', id, 'edit']">Edit search</a>
      </div>

      <ng-container *ngIf="matches.total > 0; else none">
        <div class="bar">
          <p class="counts">
            <span class="av2-chip new" *ngIf="matches.newCount > 0">{{ matches.newCount }} new since your last visit</span>
            <span>{{ matches.total }} plate{{ matches.total === 1 ? '' : 's' }} in the last 30 days</span>
            <span *ngIf="matches.priceDrops > 0">· {{ matches.priceDrops }} price drop{{ matches.priceDrops === 1 ? '' : 's' }}</span>
          </p>
          <label class="onlynew" *ngIf="matches.newCount > 0">
            <input type="checkbox" [(ngModel)]="showOnlyNew"> Show only new
          </label>
        </div>

        <ul class="rows">
          <li class="row" *ngFor="let p of rows">
            <a class="plate-link" [routerLink]="['/plate', p.registration]" [attr.aria-label]="display(p.registration) + ', ' + money(p.allInPence)">
              <span class="av2-plate plate-font">{{ display(p.registration) }}</span>
            </a>
            <div class="what">
              <span class="w-t">{{ what(p) }}</span>
              <span class="w-d">{{ p.since | date: 'd MMM' }}</span>
            </div>
            <span class="av2-chip new" *ngIf="p.isNew">New</span>
            <span class="price">{{ money(p.allInPence) }}</span>
          </li>
        </ul>
        <p class="help" *ngIf="rows.length === 0">Nothing new since your last visit.</p>

        <nav class="pager" *ngIf="pages > 1" aria-label="Pages">
          <button class="av2-btn av2-btn--ghost av2-btn--sm" [disabled]="page === 1" (click)="goPage(page - 1)">Previous</button>
          <span>Page {{ page }} of {{ pages }}</span>
          <button class="av2-btn av2-btn--ghost av2-btn--sm" [disabled]="page === pages" (click)="goPage(page + 1)">Next</button>
        </nav>
      </ng-container>

      <ng-template #none>
        <div class="empty">
          <p>Nothing new has matched yet. We'll list new plates here as they come up{{ search?.frequency !== 'none' ? ', and email you' : '' }}.</p>
          <p class="empty-more" *ngIf="forSale && forSale.available && forSale.sample.length === 0">Nothing on sale matches today either.</p>
        </div>
        <ng-container *ngIf="forSale && forSale.available && forSale.sample.length > 0">
          <h2 class="h2">For sale now</h2>
          <p class="help">{{ forSale.approximate ? 'At least ' : '' }}{{ forSale.currentlyListed.toLocaleString() }} plate{{ forSale.currentlyListed === 1 ? '' : 's' }} match today. The newest:</p>
          <ul class="rows">
            <li class="row" *ngFor="let p of forSale.sample">
              <a class="plate-link" [routerLink]="['/plate', p.registration]" [attr.aria-label]="display(p.registration) + ', ' + money(p.allInPence)">
                <span class="av2-plate plate-font">{{ display(p.registration) }}</span>
              </a>
              <div class="what"><span class="w-t">For sale</span><span class="w-d" *ngIf="p.since">listed {{ p.since | date: 'd MMM y' }}</span></div>
              <span class="price">{{ money(p.allInPence) }}</span>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </ng-container>
  </div>
</div>
